import layer from "../../../static/js/layer.js";
export function jAlert3(msg, time) {
  var time = time ? time : 2;
  layer.open({
    content: msg,
    skin: "msg",
    time: time
  });
}

export function jAlert5(msg, successFn, failFn,content,title) {
  layer.open({
    title:title||"温馨提示",
    content: content||msg,
    skin:"lvyun",
    btn: ["确认", "取消"],
    yes: index => {
      layer.close(index);
      successFn && successFn();
    },
    no: function(index, layero) {
      failFn && failFn();
    }
  });
}
export function jAlert6(msg,btnOk,btnCancel,successFn, failFn,content,title) {
  layer.open({
    title:title||"温馨提示",
    content: content||msg,
    skin:"lvyun",
    btn: [btnOk, btnCancel],
    yes: index => {
      layer.close(index);
      successFn && successFn();
    },
    cancel: function(index, layero) {
      failFn && failFn();
    }
  });
}

export function closeAlert(){
  try{
    layer.closeAll();
  }
  catch(error){
    console.log(error)
  }
}
export function jAlert12(obj) {
  layer.open({
    content: obj.content || obj.msg,
    skin: "lvyun",
    btn: obj.btn||["确认", "取消"],
    shadeClose: false,
    yes: index => {
      if(!obj.sureNotClose){
        layer.close(index);
      }
      obj.successFn && obj.successFn();
      if (obj.sureNotClose) {
        return false;
      }
    },
    no: index => {
      layer.close(index);
      obj.failFn && obj.failFn();
    },
    cancel: function (index, layero) {
      obj.failFn && obj.failFn();
    }
  });
}



// WEBPACK FOOTER //
// ./src/base/jAlert/jAlert.js